import { render, staticRenderFns } from "./InvoiceInboundsLeader.vue?vue&type=template&id=392a773a&"
import script from "./InvoiceInboundsLeader.vue?vue&type=script&lang=js&"
export * from "./InvoiceInboundsLeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports